/**
 * @Author: v_jppjpeng
 * @Date: 2024-11-08 17:47:59
 * @Explain: 周期活动
 */

export default {
  // 周期提交确认框
  'CYCLE.ACTIVITY.CYCLE.SUBMIT.CONFIRM.LATEST.CYCLE':
    '最新周期为周期{latestCycle}。',
  'CYCLE.ACTIVITY.CYCLE.SUBMIT.CONFIRM.REPLACEMENT.DESC1':
    '已错过 <b class="color-333">周期 {letSlipCycle}</b>。',
  'CYCLE.ACTIVITY.CYCLE.SUBMIT.CONFIRM.REPLACEMENT.DESC2':
    '已错过 <b class="color-333">周期 {letSlipCycle}</b>，可选择补发 <b class="color-333">周期 {reissueCycle}</b>。',
  'CYCLE.ACTIVITY.CYCLE.REISSUE.INSTRUCTIONS':
    '当前时间点距离下一周期发件时间点<br/>大于{num}小时，故可立即补发。',
  'CYCLE.ACTIVITY.IMMEDIATE.REPLACEMENT': '立即补发',
  'CYCLE.ACTIVITY.NEXT.SETTING': 'OK，下一步',

  // 列表
  'CYCLE.ACTIVITY.LIST.DETAILS': '周期详情',

  // 周期列表 - 开始
  'CYCLE.ACTIVITY.LIST.ACTION.START.TITLE': '确认开启活动？',
  'CYCLE.ACTIVITY.LIST.ACTION.START.DESC':
    '活动开启后，如有修改会按修改后的配置发件。',

  // 周期详情
  'CYCLE.ACTIVITY.LIST.TIME.LINE.CYCLE.DETAILS.START.AND.ENDS':
    '周期起止日期：',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.CYCLE.DETAILS.SENDER': '收件人：',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO':
    '<span class="color-666"> 由 <span class="color-333">{old}</span> 修改为 <span class="color-333">{new}</span></span>',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.SEND.TIME': '发送时间',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.SEND.TIME.FIXED': '固定发送时间',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.SEND.TIME.BEST': '建议发送时间',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.SEND.TIME.LOCAL': '当地时间',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.SENDER': '收件人',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.SENDER.TAG': '标签',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.SENDER.SEGMENT': '分层',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.SENDER.SUBSCRIBE': '订阅状态',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.TEMPLATE': '邮件模板',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.CYCLE.START.TIME': '周期开始时间',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.CYCLE.END.TIME': '周期结束时间',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.CYCLE.FREQUENCY': '周期频率',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.CYCLE.FREQUENCY.DAY': '每天',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.CYCLE.FREQUENCY.WEEK': '每周{str}',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.CYCLE.FREQUENCY.MONTH':
    '每月{str}号',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.DUPLICATE.REMOVAL': '去重逻辑',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.DUPLICATE.REMOVAL.ISNOREPETITION.0':
    '不去重',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.DUPLICATE.REMOVAL.ISNOREPETITION.1':
    '去重',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.DUPLICATE.REMOVAL.ISREMOVEPERMANCENT.1':
    '永久去重',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.DUPLICATE.REMOVAL.ISREMOVEPERMANCENT.2':
    '以{num}天为周期周期内去重',

  // 创建

  // 创建周期 - 发布提醒
  'CYCLE.ACTIVITY.POST.A.REMINDER': '发布提醒',
  'CYCLE.ACTIVITY.POST.A.REMINDER.DESC1':
    '活动发布后，到达开始时间会开始发件。',

  // 创建周期 - 发送给
  'CYCLE.ACTIVITY.EXPECTED.DELIVERY.DAYS1':
    '预计<b class="font-poppins">{num}天</b>内可投递完本周期内所有联系人',

  // 创建周期 - 选择内容
  'CYCLE.ACTIVITY.LANGUAGE.SETTING': '语言设置',
  'CYCLE.ACTIVITY.SEARCH.LANGUAGE': '搜索语言',
  'CYCLE.ACTIVITY.SELECT.LANGUAGE.TIPS':
    '除首个周期包含的联系人语言外，可在此添加需要配置的其他语言。',

  // 创建周期 - 时间计划
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE.DATE.LABEL': '周期起止日期',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.START.AT': '开始于',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.END.AT': '结束于',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE.FREQUENCY.LABEL': '周期频率',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE.FREQUENCY.PLACEHOLDER':
    '请选择周期频率',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.SENDING.TIME.LABEL': '发件时间',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.PLEASE.FIXED.TIME': '请选择固定递送时间',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.PLEASE.LOCAL.TIME': '请选择当地时间',

  'CYCLE_ACTIVITY.SCHEDULE.TIME.RANGE.TITLE': '时间修改覆盖范围选择',
  'CYCLE_ACTIVITY.SCHEDULE.TIME.RANGE.REMINDER':
    '请确认发件时间变更的应用范围，设置后可在周期详情查看每个周期的发送时间',

  'CYCLE_ACTIVITY.SCHEDULE.TIME.RANGE.LOGIC.1': '覆盖启动后的所有周期',
  'CYCLE_ACTIVITY.SCHEDULE.TIME.RANGE.LOGIC.2': '只应用于启动后的首个周期',

  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE_FREQUENCY_MONDAY': '星期一',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE_FREQUENCY_TUESDAY': '星期二',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE_FREQUENCY_WEDNESDAY': '星期三',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE_FREQUENCY_THURSDAY': '星期四',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE_FREQUENCY_FRIDAY': '星期五',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE_FREQUENCY_SATURDAY': '星期六',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE_FREQUENCY_SUNDAY': '星期日',

  'CYCLE_ACTIVITY.CREATE_SCHEDULE.CYCLE_DAY_PREFIX': '{day}号',

  // 审批周期 - 审批提醒
  'CYCLE.ACTIVITY.APPROCAL.TITLE': '审批提醒',
};
